module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMADQgisYUAAAAWSURBVBjTY/zPAAYNYMS4atDyhog7ARMbKLNFvyl0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-4/blueprint.png
// module id = 2cB3
// module chunks = 1